import { useAtom } from 'jotai'

import { passwordForgetEmailStore } from 'src/stores'

export const usePasswordForgetEmailStore = () => {
  const [passwordForgetEmailStoreValue, setPasswordForgetEmailStoreValue] = useAtom(
    passwordForgetEmailStore.email
  )

  return {
    passwordForgetEmailStoreValue,
    setPasswordForgetEmailStoreValue,
  }
}
